/* nuvo-moneda.js · molde v1.3j (28/09/2026): los importes FIJOS del tema en la moneda del cliente.

   Los precios de Shopify (producto, carrito, checkout) ya llegan en la moneda del cliente
   (Markets con monedas locales). Pero lo que el tema pinta a partir de un ajuste (el umbral del
   envío gratis, la tarifa de envío, lo que se ahorra en un pack) está en la moneda de la TIENDA:
   el filtro `money` le pone el formato del cliente pero NO lo convierte. Con la tienda en euros,
   un cliente en dólares veía «Envío gratis desde 40 $» cuando el umbral real era 46,80 $, y el
   pack de 3 con los euros escritos como dólares.

   Aquí se convierte con el tipo que Shopify publica en la propia página (Shopify.currency.rate),
   el mismo con el que convierte los descuentos fijos y las condiciones de envío.

   Marcado (lo pinta el Liquid en la moneda de la tienda; en otra moneda se reescribe):
     <span data-nuvo-base="4000" data-nuvo-sin-ceros>40 €</span>      un importe suelto
     <div data-nuvo-umbral="4000" data-nuvo-llevo="2690">…</div>       el envío gratis del carrito:
        dentro, [data-nuvo-si-falta] / [data-nuvo-si-hecho] se enseñan o se esconden,
        [data-nuvo-falta] lleva lo que falta y [data-nuvo-pct] el porcentaje.
   Lo que se pinta después (la ventana del carrito se repinta entera al añadir) se convierte solo.

   Prueba sin tienda en otra moneda: ?nuvo_prueba_moneda=USD:1.17 (solo mueve estos importes).
*/
(function () {
  var C = window.NUVO_MONEDA_CFG || {};
  var S = (window.Shopify && window.Shopify.currency) || {};
  var base = C.base || '';
  var activa = S.active || C.activa || base;
  var tasa = parseFloat(S.rate);
  var prueba = /[?&]nuvo_prueba_moneda=([A-Z]{3}):([\d.]+)/.exec(window.location.search);
  if (prueba) { activa = prueba[1]; tasa = parseFloat(prueba[2]); }
  if (!(tasa > 0)) { tasa = 1; }
  var distinta = !!(base && activa && base !== activa);

  /* El formato de la moneda del cliente se aprende de un importe que pinta Shopify: 1234,00
     («1.234,00 €», «$1,234.00», «¥1,234», «1 234,00 kr»). */
  var fmt = (function (t) {
    t = String(t || '').replace(/ /g, ' ');
    var m = t.match(/^(.*?)1([^0-9]?)234(?:([^0-9])(\d+))?(.*)$/);
    if (!m) { return { pre: '', mil: '.', dec: ',', dig: 2, post: ' ' + activa }; }
    return { pre: m[1], mil: m[2] || '', dec: m[3] || ',', dig: m[4] ? m[4].length : 0, post: m[5] };
  })(C.muestra);

  function formatear(c, sinCeros) {
    var s = ((c || 0) / 100).toFixed(fmt.dig);
    var p = s.split('.');
    var ent = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, fmt.mil);
    var dec = p[1] || '';
    if (sinCeros && /^0+$/.test(dec)) { dec = ''; }
    return fmt.pre + ent + (dec ? fmt.dec + dec : '') + fmt.post;
  }
  /* de céntimos de la tienda a céntimos del cliente (las monedas sin decimales, a la unidad) */
  function convertir(c) {
    if (!distinta) { return c; }
    var v = Math.round((c || 0) * tasa);
    return fmt.dig === 0 ? Math.round(v / 100) * 100 : v;
  }

  function envioGratis(root) {
    (root || document).querySelectorAll('[data-nuvo-umbral]:not([data-nuvo-hecho])').forEach(function (b) {
      var umbral = convertir(parseInt(b.getAttribute('data-nuvo-umbral'), 10) || 0);
      var llevo = parseInt(b.getAttribute('data-nuvo-llevo'), 10) || 0;
      var falta = umbral - llevo;
      var pct = umbral > 0 ? Math.min(100, Math.round(llevo * 100 / umbral)) : 100;
      b.setAttribute('data-nuvo-hecho', String(umbral));
      if (b.hasAttribute('data-kit-ship')) { b.classList.toggle('is-done', falta <= 0); }
      b.querySelectorAll('[data-nuvo-si-falta]').forEach(function (x) { x.hidden = falta <= 0; });
      b.querySelectorAll('[data-nuvo-si-hecho]').forEach(function (x) { x.hidden = falta > 0; });
      b.querySelectorAll('[data-nuvo-falta]').forEach(function (x) { x.textContent = formatear(Math.max(0, falta)); });
      b.querySelectorAll('[data-nuvo-pct]').forEach(function (x) { x.textContent = pct + ' %'; });
      b.querySelectorAll('.nuvo-sky__fill').forEach(function (x) { x.style.width = pct + '%'; });
      b.querySelectorAll('[role=progressbar]').forEach(function (x) { x.setAttribute('aria-valuenow', pct); });
      b.querySelectorAll('.nuvo-sky__viajero').forEach(function (x) { x.style.left = pct + '%'; });
    });
  }

  function aplicar(root) {
    if (!distinta) { return; }
    (root || document).querySelectorAll('[data-nuvo-base]:not([data-nuvo-hecho])').forEach(function (e) {
      var v = convertir(parseInt(e.getAttribute('data-nuvo-base'), 10) || 0);
      e.textContent = formatear(v, e.hasAttribute('data-nuvo-sin-ceros'));
      e.setAttribute('data-nuvo-hecho', String(v));
    });
    envioGratis(root);
  }

  /* ---------------------------------------------------------------------------------------
     v1.3k (28/09/2026) · LA MONEDA QUE SHOPIFY NO COBRA.
     Shopify Payments no admite el peso argentino, el colombiano, el chileno, el mexicano ni el
     real (entre otras): a esos países la tienda les enseña y les cobra la moneda base.
     Debajo de cada precio marcado se pinta el importe APROXIMADO en la moneda del país y en qué
     moneda se cobra. No cambia lo que se cobra: informa, y lo dice.

     Marcado:  <p class="nuvo-aprox" data-nuvo-aprox="[data-price]" hidden></p>
               (el selector es el del precio del que sale, dentro de la misma ficha o carrito)
     Los tipos son los de currencies.js, que publica Shopify en su CDN. Solo se pide si el país
     es de la tabla y la tienda le está enseñando la moneda base.
     Prueba sin salir de casa: ?nuvo_prueba_pais=AR                                         */
  var LOCAL = {
    /* país: [moneda, nombre en español, nombre en inglés, redondeo] */
    AR: ['ARS', 'pesos argentinos', 'Argentine pesos', 100],
    CO: ['COP', 'pesos colombianos', 'Colombian pesos', 100],
    CL: ['CLP', 'pesos chilenos', 'Chilean pesos', 100],
    MX: ['MXN', 'pesos mexicanos', 'Mexican pesos', 1],
    BR: ['BRL', 'reales', 'Brazilian reais', 1],
    NO: ['NOK', 'coronas noruegas', 'Norwegian kroner', 1],
    TR: ['TRY', 'liras turcas', 'Turkish lira', 1],
    ZA: ['ZAR', 'rands', 'South African rand', 1]
  };
  var NOMBRE_BASE = { EUR: ['euros', 'euros'], USD: ['dólares', 'US dollars'], GBP: ['libras', 'pounds'] };
  var pruebaPais = /[?&]nuvo_prueba_pais=([A-Z]{2})/.exec(window.location.search);
  var pais = pruebaPais ? pruebaPais[1] : (C.pais || (window.Shopify && window.Shopify.country) || '');
  var loc = LOCAL[pais];
  var ingles = String(C.idioma || '').toLowerCase().indexOf('en') === 0;
  var conAprox = !!(loc && base && !distinta && loc[0] !== base);

  /* «1.234,56 €» → céntimos, con el formato que se aprendió arriba */
  function leer(t) {
    var s = String(t || '').replace(/[^0-9.,]/g, '');
    var i = fmt.dig > 0 ? s.lastIndexOf(fmt.dec) : -1;
    /* un separador con tres cifras detrás es de millares, no de decimales («1.234») */
    if (i >= 0 && s.length - i - 1 > 2) { i = -1; }
    var ent = (i >= 0 ? s.slice(0, i) : s).replace(/[^0-9]/g, '');
    var dec = ((i >= 0 ? s.slice(i + 1).replace(/[^0-9]/g, '') : '') + '00').slice(0, 2);
    return (parseInt(ent || '0', 10) * 100) + parseInt(dec, 10);
  }
  function miles(n) {
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ingles ? ',' : '.');
  }
  var tipos = null, pidiendo = false, enCola = [];
  function conTipos(hecho) {
    if (tipos) { hecho(); return; }
    enCola.push(hecho);
    if (pidiendo) { return; }
    pidiendo = true;
    var listo = function () {
      var r = window.Currency && window.Currency.rates;
      if (r && r[base] > 0 && r[loc[0]] > 0) { tipos = r; enCola.splice(0).forEach(function (f) { f(); }); }
    };
    if (window.Currency && window.Currency.rates) { listo(); return; }
    var sc = document.createElement('script');
    sc.src = 'https://cdn.shopify.com/s/javascripts/currencies.js';
    sc.async = true;
    sc.onload = listo;
    document.head.appendChild(sc);
  }
  function aproximar(root) {
    if (!conAprox) { return; }
    var marcas = (root || document).querySelectorAll('[data-nuvo-aprox]:not([data-nuvo-aprox-ok])');
    if (!marcas.length) { return; }
    conTipos(function () {
      var factor = tipos[base] / tipos[loc[0]];
      var cobro = (NOMBRE_BASE[base] || [base, base])[ingles ? 1 : 0];
      marcas.forEach(function (e) {
        if (e.hasAttribute('data-nuvo-aprox-ok')) { return; }
        var ambito = e.closest('[data-nuvo-product], cart-drawer, #CartDrawer') || document;
        var origen = ambito.querySelector(e.getAttribute('data-nuvo-aprox'));
        if (!origen) { return; }
        e.setAttribute('data-nuvo-aprox-ok', loc[0]);
        var poner = function () {
          var c = leer(origen.textContent);
          if (!(c > 0)) { e.hidden = true; return; }
          var v = Math.round((c / 100) * factor / loc[3]) * loc[3];
          var t = '≈ ' + miles(v) + ' ' + loc[ingles ? 2 : 1] + ' · ' +
                  (ingles ? 'charged in ' : 'se cobra en ') + cobro;
          if (e.textContent !== t) { e.textContent = t; }
          e.hidden = false;
        };
        poner();
        if (window.MutationObserver) {
          new MutationObserver(poner).observe(origen, { childList: true, characterData: true, subtree: true });
        }
      });
    });
  }
  if (conAprox) {
    var hoja = document.createElement('style');
    hoja.textContent = '.nuvo-aprox{margin:.5rem 0 0;font-size:1.25rem;line-height:1.35;font-weight:600;' +
      'color:rgba(var(--np-ink-rgb,15,27,45),.62)}.nuvo-aprox[hidden]{display:none}' +
      '#CartDrawer .nuvo-aprox{text-align:right;font-size:1.15rem;margin-top:.2rem}';
    document.head.appendChild(hoja);
  }

  window.NUVO_MONEDA = { base: base, activa: activa, tasa: tasa, distinta: distinta,
                         formatear: formatear, convertir: convertir, aplicar: aplicar,
                         pais: pais, aprox: conAprox ? loc[0] : '', aproximar: aproximar, leer: leer };

  function arrancar() {
    aplicar(document);
    aproximar(document);
    if (conAprox && window.MutationObserver) {
      /* la ventana del carrito se repinta entera al añadir: lo nuevo se marca solo */
      var espera = false;
      new MutationObserver(function () {
        if (espera) { return; }
        espera = true;
        requestAnimationFrame(function () { espera = false; aproximar(document); });
      }).observe(document.body, { childList: true, subtree: true });
    }
    if (!distinta || !window.MutationObserver) { return; }
    var pendiente = false;
    new MutationObserver(function (cambios) {
      if (pendiente) { return; }
      for (var i = 0; i < cambios.length; i++) {
        var nodos = cambios[i].addedNodes;
        for (var j = 0; j < nodos.length; j++) {
          var n = nodos[j];
          if (n.nodeType === 1 && (n.matches('[data-nuvo-base],[data-nuvo-umbral]') ||
              n.querySelector('[data-nuvo-base],[data-nuvo-umbral]'))) {
            pendiente = true;
            requestAnimationFrame(function () { pendiente = false; aplicar(document); });
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', arrancar); } else { arrancar(); }
})();
